var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5734",
    "data-name": "Group 5734",
    transform: "translate(-6.5 -5.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4509",
    "data-name": "Rectangle 4509",
    transform: "translate(8 7)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 6.5,
    height: 6.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4512",
    "data-name": "Rectangle 4512",
    transform: "translate(8 17)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 6.5,
    height: 6.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4510",
    "data-name": "Rectangle 4510",
    transform: "translate(18 7)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 6.5,
    height: 6.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4511",
    "data-name": "Rectangle 4511",
    transform: "translate(18 17)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 6.5,
    height: 6.5,
    rx: 1.75,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.170029d193328c332c5db0212003b779.svg";
export { ForwardRef as ReactComponent };